import { ArticlePreview } from '@components/article-preview'
import { HeaderSection } from '@components/header-section'
import { EditorialWithHighlights } from 'types/editorial'
import { Highlight } from 'types/highlight'

import styles from './styles.module.scss'

interface Props {
  section: EditorialWithHighlights
}

export const InfosolarStudio: React.FC<Props> = ({ section }) => {
  const findHighlightByPosition = (
    position: number,
    highlights: Highlight[]
  ): any => highlights.find(highlight => highlight.position === position)

  const layout = Array.from({ length: 10 }, (x, i) => i + 1).map(position => {
    return {
      ...findHighlightByPosition(position, section.highlights)
    }
  })

  return (
    <div className={styles.container}>
      <HeaderSection
        onPress="Veja mais"
        sendTo="/noticias/editoria/estudio-infosolar"
      >
        <h2>Estúdio Infosolar</h2>
      </HeaderSection>
      <div className={styles.mainArticles}>
        {layout.slice(0, 3).map(article => (
          <ArticlePreview
            key={article?.id}
            articlePath={article?.path}
            imageUrl={article?.thumbnailImage?.path}
            direction="top"
            title={article?.title?.slice(0, 120)}
            description={article?.shortContent?.slice(0, 100)}
            readingTime={
              article?.timeToRead && `${article?.timeToRead} min de vídeo`
            }
            articleType={article?.articleType}
            videoUrl={article?.videoUrl}
          />
        ))}
      </div>
      <div className={styles.secondaArticles}>
        {layout.slice(4, layout.length + 1).map(article => (
          <ArticlePreview
            key={article?.id}
            articlePath={article?.path}
            imageUrl={article?.thumbnailImage?.path}
            direction="left"
            title={article?.title?.slice(0, 120)}
            description={article?.shortContent?.slice(0, 100)}
            readingTime={
              article?.timeToRead && `${article?.timeToRead} min de vídeo`
            }
            articleType={article?.articleType}
            videoUrl={article?.videoUrl}
          />
        ))}
      </div>
    </div>
  )
}
